enum ReservationBusinessDayType {
  REGULAR_HOLIDAY = "REGULAR_HOLIDAY",
  BUSINESS_DAY = "BUSINESS_DAY",
}

export default ReservationBusinessDayType;
